var vms = vms || {};
vms.checklist = vms.checklist || {};

vms.checklist.questionCnt = 0;
vms.checklist.btnType = "";
vms.checklist.$btnContainer = null;

/* 26.6.2021 comment by Davor: What is this about? */
function RemoveChkOnclick() {
    $x('apexir_DEL').onclick = '';
};

/* 26.6.2021 comment by Davor: What is this about? I think this is not a part of checklists (references in FOLDER pkg) */
function spCheckChange(pThis) {
    apex.server.process("CHECKBOX_CHANGE", {
        x01: pThis.value,//Value that was checked
        x02: pThis.checked ? 'Y' : 'N' // Checked Flag
    }, {
            dataType: "text",
            success: function (pData) {
                $x('checkListDisp').innerHTML = pData;
            }
        });
};

/* 26.6.2021 comment by Davor: What is this about? I think this is not a part of checklists (references in FOLDER pkg) */
function disableDoc(pID, pOpt, pType) {
    apex.server.process("DISABLE_DOC", {
        x01: pID,
        x02: pOpt,
        x03: pType
    }, {
            dataType: "text",
            success: function (pData) {
                location.reload();
            }
        });
};

/* 26.6.2021 comment by Davor: (references only in FOLDER pkg sms_checklists) */
vms.checklist.disableChkList = function (pID, pOpt, pType) {
    apex.server.process("DISABLE_LIST", {
        x01: pID,
        x02: pOpt,
        x03: pType
    }, {
            dataType: "text",
            success: function (pData) {
                location.reload();
            }
        });
};
var disableChkList = vms.checklist.disableChkList;

//Quick Pick
/* 26.6.2021 comment by Davor: references only on pg104 (survey question setup) */
vms.checklist.quickPick = function (pItem, pType, pProfileId, pFilter) {
    apex.server.process("quickPick", {
        x01: pItem,
        x02: pType,
        x03: pProfileId,
        x04: pFilter
    }, {
            dataType: "html",
            success: function (pData) {
                if (pData) $("#quickPick").html(pData);
            }
        });
};

/* created 30.12.2021 by Davor: Closes checklist */
vms.checklist.close = function (pThis){
    var $vSelector = $(pThis).closest('.vmsSlide');
    $vSelector.slideUp(500, function (){
	if ($vSelector.hasClass("checklist") && $(".vmsSlide.checklistHistory").length != 0) {
		$(".vmsSlide.checklistHistory").slideDown(500); }
	else if ($v("checklistBtnType") == 'HISTORY_BTN') {
		$(".page-176 #history").slideDown(500);
	}
    else {$(".t-Body-contentInner").slideDown(500); $(".page-176 #taskDetails").slideDown(500);}
        $vSelector.remove();
    });
};

/* created 15.04.2022 by Miroslav: Delete checklist */
vms.checklist.delete = function (pThis){	
	if (confirm("Press OK if you want to delete this checklist.") == true) {
		var vChecklistId = $("#checklistId").val();
		apex.server.process("checklistDelete"
		, { x01: vChecklistId}
		, {
			dataType: "html",
			success: function (pData) {
				vms.checklist.close(pThis);
				//Procedure History
				if($('table#history').length) {
					$("div#BTN"+vChecklistId).closest('tr').toggle();
					console.log('history table exist');
				}
				//Task List
				if($('div#irDPA').length || $('div#ir0').length || $('div#ir1').length || $('div#ir3').length || $('div#ir4').length) {
					$("#checklistTask"+vChecklistId).remove();
					console.log('task list table exist');
				}
				//PP Checklists
				if($('div#checklistIR').length) {
					apex.region("checklistIR").refresh();
					console.log('PP checklist table exist');
				}
			}
		});
	}
};

/* created 09.05.2023 by Miroslav: Delete checklist */
vms.checklist.getTemp = function (pSurId) {
	apex.server.process("checklistGetTemp"
		, { x01: pSurId}
		, {
			dataType: "text",
			success: function (r) {
				vms.checklist.get(r.replace(/\s/g, ''),0,'HISTORY_BTN',pSurId, this);
			}
		});
};

/* (checklistGet) p142_type  
* shows checklist (already created)
*/
vms.checklist.get = function (pChklId, pOwner, pType, pTaskId, pThis) {
    vms.checklist.$btnContainer = $(pThis).parent();
    vms.checklist.btnType = pType;
    vms.load.add(null, true);
	apex.server.process("checklistGet"
		, { x01: pChklId,
			x02: pOwner,
			x03: vms.checklist.btnType,
			x04: pTaskId}
		, {
			dataType: "html",
			success: function (pData) {
				var vSplit=pData.split('~~');
                $(".checklist").remove();
				$("#main").append(vSplit[1]);
				$(".t-Dialog").append(vSplit[1]); 
                vms.checklist.questionCnt = $(".chklProgress").attr("max");
                var $vSelector = $(".vmsSlide.checklistHistory");
				console.log('vms.checklist.get');
			if ($vSelector.length == 0) {$vSelector = $(".t-Body-contentInner"); $vSelector = $(".page-176 #history");}
                vms.load.remove();
				$vSelector.slideUp(500, function (){ $(".vmsSlide.checklist").slideDown(500); });
			}
		});
};
/* bkp 30.03.2021
vms.checklist.get = function (pChklId, pOwner, pType) {
	vms.checklist.type = ('TASK_CHECKLIST_BTN' || pType=='TASK_LIST' ? 'INLINE' : 'POPUP');
    
	apex.server.process("checklistGet"
		, { x01: pChklId,
			x02: pOwner,
			x03: vms.checklist.type}
		, {
			dataType: "html",
			success: function (pData) {
				var vSplit=pData.split('~~');
				var vColspan='9';
				if (vSplit[0]=='S') vColspan='10';
				if (vms.checklist.type=='INLINE') {
					$('#checklistTask3').remove();
					$("#checklistTask2").after('<tr id="checklistTask3"><td colspan="'+vColspan+'">' + vSplit[1] + '</td></tr>');
					vms.checklist.questionCnt = $(".chklProgress").attr("max");
				}
				else {
					$("body").append(vSplit[1]); vms.checklist.questionCnt = $(".chklProgress").attr("max");
					$('html, body').animate({ scrollTop: $(".vmsPopupContent").offset().top - 60 }, 'slow');
				}
			}
		});
};*/

/* Created on 11.04.2019 by Davor (checklistInit)
* Initiates(creates) a new checklist in db, and shows it ready for answering
*/
vms.checklist.init = function (pSurvey, pRec, pEty, pType, pThis) {
	vms.checklist.btnType=pType;//('TASK_CHECKLIST_BTN' || pType=='TASK_LIST' ? 'INLINE' : 'POPUP');
    vms.checklist.$btnContainer = $(pThis).parent();
    apex.server.process("checklistInit"
        , { x01: pSurvey, x02: pRec, x03: pEty, x04: vms.checklist.btnType }
        , {
            dataType: "html",
            success: function (pData) {
				console.log(pSurvey+', '+pRec+', '+pEty+', '+pType+', '+pThis);
				console.log(pSurvey+', '+pRec+', '+pEty+', '+vms.checklist.btnType);
				//console.log(pData);
				var vSplit=pData.split('~~');
                // button refresh
                vms.checklist.$btnContainer.find('.t_pm_button').remove();
                vms.checklist.$btnContainer.append(vSplit[0]);
                // show checklist
                $("#main").append(vSplit[1]); 
				$(".t-Dialog").append(vSplit[1]); 
                vms.checklist.questionCnt = $(".chklProgress").attr("max");
                $(".t-Body-contentInner").slideUp(500, function (){ $(".vmsSlide.checklist").slideDown(500); });
                $("#taskDetails").slideUp(500, function (){ $(".vmsSlide.checklist").slideDown(500); });
            }
        });
}
/* Created on 30.06.2017 by Davor (checklistHistory)
   Modified by Miroslav */
vms.checklist.history = function (pRec, pEty, pSur, pType) {
	console.log('1 '+pRec+', '+pEty+', '+pSur+', '+pType);
    $(".checklistHistory").remove();
    apex.server.process("checklistHistory"
        , { x01: pRec, x02: pEty, x03: pSur, x04: pType }
        , {
            dataType: "html",
            success: function (pData) {
			  console.log('2 '+pRec+', '+pEty+', '+pSur+', '+pType);
              if (pType=='INLINE') {
					      $("#chkHist").remove();
                //$("td[headers*='taskName']").closest('tr').after('<tr><td colspan="8">' + pData + '</td></tr>');    
                $("input[id*='taskID"+pRec+"']").closest('tr').after('<tr id="chkHist"><td colspan="8">' + pData + '</td></tr>');
					      vms.checklist.questionCnt = $(".chklProgress").attr("max");
              }
              else {
				console.log(pData);
                $(".checklist").remove();
                $("#main").append(pData);
                $(".t-Body-contentInner").slideUp(500, function (){ $(".vmsSlide").slideDown(500); });
              }
            }
        });
};

/* Created on 11.12.2020 by Miroslav (checklistTask)*/
vms.checklist.task = function (pTaskId, pIitId, pExpired, pClosed, pProfileId) {
    $("tr[id*='checklistTask']").remove();
    vms.load.add(null, true);
    apex.server.process("checklistTask"
        , { x01: pTaskId, x02: pIitId, x03: pExpired, x04: pClosed, x05: pProfileId }
        , {
            dataType: "html",
            success: function (pData) {
                vms.load.remove();
              $("input[id*='taskID"+pTaskId+"']").closest('tr').after(pData);
		          //vms.checklist.questionCnt = $(".chklProgress").attr("max");
            }
        });
};
/* Created on 28.06.2017 by Davor (checklistOpenQ)*/
vms.checklist.openQ = function (pSeq, pqMax) {
    /* Created on 31.07.2020 by Miroslav */
    function checklistGetQID(pSeqNo) {
        var vRet = '';
        $("tbody tr.question td#seqno").each(
            function(){
                var seqno = '';
                var qid = '';
                seqno = $(this).text();
                qid = $(this).closest("tr").attr("qid");
                if (seqno == pSeqNo) {
                    vRet = qid;
                    return false;
                }
            }
        );
        return vRet;
    }
    var vQuestionId = checklistGetQID(pSeq);
    var vSeq = pSeq;//$(".vmsPopup tr[qid="+ pQuestionId +"] .qNr").text();
    vms.load.add(null, true);
    apex.server.process("checklistOpenQ"
        , { x01: $v("checklistId"), x02: vQuestionId, x03: vSeq, x04: pqMax }
        , {
            dataType: "html",
            success: function (pData) {
                vms.load.remove();
                $(".chklQuestionContainer").html(pData);
                if (pSeq == 1) {
                    $(".chklBtn.prev").addClass("hidden");
                    $(".chklBtn.blankP").removeClass("hidden");
                    $(".chklBtnSmall.prev").addClass("hidden");
                    $(".chklBtnSmall.blankP").removeClass("hidden");
					$(".chklBtn.blankP").attr("onclick","");
					$(".chklBtn.next").attr("onclick","vms.checklist.shiftQ("+(vSeq+1)+","+pqMax+");");
                }
                else {
                    $(".chklBtn.prev.hidden").removeClass("hidden");
                    $(".chklBtn.blankP").addClass("hidden");
                    $(".chklBtnSmall.prev.hidden").removeClass("hidden");
                    $(".chklBtnSmall.blankP").addClass("hidden");
					$(".chklBtn.prev").attr("onclick","vms.checklist.shiftQ("+(vSeq-1)+","+pqMax+");");
					$(".chklBtn.next").attr("onclick","vms.checklist.shiftQ("+(vSeq+1)+","+pqMax+");");
                }

                if (pSeq == vms.checklist.questionCnt) {
                    $(".chklBtn.next").addClass("hidden");
                    //$(".chklBtnSmall.next").addClass("hidden");
                    $(".chklBtnSmall.blankN").removeClass("hidden");
                    //$(".chklBtn.finish.hidden").removeClass("hidden");
                } else {
                    $(".chklBtn.next.hidden").removeClass("hidden");
                    $(".chklBtnSmall.blankN").addClass("hidden");
                    //$(".chklBtnSmall.next.hidden").removeClass("hidden");
                    //$(".chklBtn.finish").addClass("hidden");
                }			
				$("tbody tr.question").each(
					function(){
						var qid = '';
						qid = $(this).attr("qid");
						if (vQuestionId == qid) {
							$(this).addClass("selected");
							$(this).children("#seqno").addClass("selected");
						}
						else {
							$(this).removeClass("selected");
							$(this).children("#seqno").removeClass("selected");					
						}
					}
				);
            }
        });
};

vms.checklist.signChange = function (pThis){
    if (pThis.value != 0) vms.btn.hightlight("btnAddSig");
    else vms.btn.unhightlight("btnAddSig");
}

vms.checklist.signForm = function (pSubmit){
    //alert("Under construction!");
    if (pSubmit){
        var vQuestionId = $v("chklQuestionId");
        var vQuestionType = $v("chklQuestionType");
        var vChecklistId = $v("chklId");
        var vProfileId = $v("chklSig");
        var vSigPassword = $v("chklSigPass");
        vms.load.add(null, true);
        apex.server.process("checklistQSign"
            , { x01: vChecklistId, x02: vQuestionId, x03: vProfileId, x04: vSigPassword, x05: vms.checklist.btnType, x06: vQuestionType }
            , {
                dataType: "json",
                success: function (d) {
                    vms.load.remove();
                    if (d.ok) {
                        // refresh question in list (with history)
                        vms.checklist.setIrResponse(vQuestionId, d.response, $(".chklProgress").attr("max"), d.history);
                        // refresh question
                        $(".chklQuestionContainer .signatureForm").html(d.question);
                        $("#formChecklistSign").dialog("close");
                        // refresh checklist button
                        vms.checklist.$btnContainer.find('.t_pm_button').remove();
                        vms.checklist.$btnContainer.append(d.btn);
                    } else alert(d.err);
                }
            });
    } else if ($v("chklSig") == 0) {
        alert("Please select an employee.")
    } else {
        $('<div id="formChecklistSign">'+
            '<div class="dialogContendBody">'+ vms.item.gen({type:"P",id:"chklSigPass",label:"Enter password/pin",def:null, widthPct:"100"}) +'</div>'+
            '<div class="dialogButtonContainer">'+ vms.btn.gen({"label":"Sign","js":"vms.checklist.signForm(true);", fa: 'fas fawe-signature'}) +'</div>'+
          '</div>').dialog({ title: 'Sign with password', 
                            close: function(event, ui) { $(this).dialog('close').remove(); } 
                        });
            $("#chklSigPass")[0].addEventListener("keyup", function(event) {
                            if (event.keyCode === 13) {
                              event.preventDefault();
                              // Submit pass
                              vms.checklist.signForm(true);
                            }
                          });
    }
}

vms.checklist.signRemove = function (pId, pSubmit){
    //alert("Under construction!");
    if (pSubmit){
        var vQuestionId = $v("chklQuestionId");
        var vQuestionType = $v("chklQuestionType");
        var vChecklistId = $v("chklId");
        var vProfileId = pId;
        vms.load.add(null, true);
        apex.server.process("checklistQSignRemove"
            , { x01: vChecklistId, x02: vQuestionId, x03: vProfileId, x04: vms.checklist.btnType, x05: vQuestionType }
            , {
                dataType: "json",
                success: function (d) {
                    vms.load.remove();
                    if (d.ok) {
                        // refresh question in list (with history)
                        console.log(d.response);
                        vms.checklist.setIrResponse(vQuestionId, d.response, $(".chklProgress").attr("max"), d.history);
                        // refresh question
                        $(".chklQuestionContainer .signatureForm").html(d.question);
                        $("#formChecklistSign").dialog("close");
                        // refresh checklist button
                        vms.checklist.$btnContainer.find('.t_pm_button').remove();
                        vms.checklist.$btnContainer.append(d.btn);
                    } else alert(d.err);
                }
            });
    } else {
        $('<div id="formChecklistSign"><div class="dialogContendBody">Are you sure you want to remove this signature!</div>'+
            '<div class="dialogButtonContainer">'+ vms.btn.gen({"label":"Yes","js":"vms.checklist.signRemove("+ pId +", true);", fa: 'fas fawe-trash-alt'}) +'</div>'+
          '</div>').dialog({ title: 'Warning', 
                            close: function(event, ui) { $(this).dialog('close').remove(); } 
                        });
    }
}
/* Created on 29.06.2017 by Davor (checklistSubmitQ)*/
vms.checklist.submitQ = function (pNextQ, pTaskId, pqMax) {
    /* Created on 31.07.2020 by Miroslav (checklistSeqNoColor)
    * Commented by Davor and logic implemented in vms.checklist.setIrResponse
    
    function checklistSeqNoColor(pSeqNo,pResponse) {
        var vRet = '';
        $("tbody tr.question td#seqno").each(
            function(){
                var seqno = '';
                var qid = '';
                seqno = $(this).text();
                qid = $(this).closest("tr").attr("qid");
                if (seqno == pSeqNo) {
                    if (pResponse == null || pResponse == '') {
                        //alert("1-"+pSeqNo+"-"+pResponse);
                        $(this).removeClass("green");
                        $(this).addClass("blue");
                    }
                    else {
                        //alert("2-"+pSeqNo+"-"+pResponse);
                        $(this).removeClass("blue");
                        $(this).addClass("green");
                    }
                    return false;
                }
            }
        );
    }*/
    var vQuestionType = $v("chklQuestionType");
    var vQuestionId = $v("chklQuestionId");
    var vChecklistId = $v("chklId");
    //var vChecklistType = $v("checklistType");
    var vResponse, vCheckboxVals = [], vComments, vCommentVals = [];
    switch (vQuestionType) {
        case 'CBX':
            $("input[name=chklResponse]:checked").each(function () { vCheckboxVals.push(this.value); });
            vResponse = vCheckboxVals.join(":");
			$("textarea[name=choiceCmt]").each(function () { vCommentVals.push(this.value); });
			vComments = vCommentVals.join("~");
            break;
        case 'RAD':
            vResponse = $("input[name=chklResponse]:checked").val();
            break;
        case 'RAD2':
            vResponse = $("input[name=chklResponse]:checked").val();
			$("textarea[name=choiceCmt]").each(function () { vCommentVals.push(this.value); });
			vComments = vCommentVals.join("~");
            break;
		case 'RAD_YNA':
            vResponse = $("input[name=chklResponse]:checked").val();
            break;	
        case 'UPD':
            //if(pNextQ) checklistOpenQ(pNextQ);return;
            vResponse = $(".vms" + vChecklistType + " tr[qid=" + vQuestionId + "] .resp").html();
            break;
        case 'EMP':             
            vResponse = $("#chklEmp").val().join(":");
            break;
        case 'CRW':             
            vResponse = $("#chklEmp").val().join(":");
            break;
		case 'EMP_O':             
            vResponse = $("#chklEmp").val().join(":");
			break;
		case 'ENG':             
            vResponse = $("#chklEng").val().join(":");
			break;
		case 'EP':             
            vResponse = $("#chklEp").val().join(":");
			break;
		case 'HSE':             
            vResponse = $("#chklHse").val().join(":");
			break;
		case 'VSL':             
            vResponse = $("#chklVsl").val().join(":");
			break;;
		case 'VSLS':             
            vResponse = $("#chklVsls").val().join(":");
			break;
		case 'WP':             
            vResponse = $("#chklWp").val().join(":");
			break;			
        default:
            vResponse = $v("chklResponse");
    }
    vms.load.add(null, true);
    apex.server.process("checklistSubmitQ"
        , { x01: $v("checklistId"), x02: vQuestionId, x03: vResponse, x04: $v("chklNote"), x05: vms.checklist.btnType, x06: vComments }
        , {
            dataType: "json",
            success: function (d) {
                vms.load.remove();
                if (d.ok) {
                    // refresh question in list (with history)
                    vms.checklist.setIrResponse(vQuestionId, d.response, pqMax, d.history);
					//vms.checklist.responseShow(vChecklistId, vQuestionId, vResponse);
                    if (pNextQ == 0) {
						vms.checklist.end("C", pTaskId, vResponse);
						/*if ($v("checklistTaskId")) {
							vms.info.confirm('Do you want to sign off status task?', 
									(okPressed)=>{if( okPressed ) {lxCloseTask($v("checklistTaskId"), this);}},
									{ok:'Yes',cancel:'No'});
						}*/
					}
                    else if (pNextQ) {
                        vms.checklist.openQ(pNextQ, pqMax);
                        // Refresh calling button
                        //$(".t_task[task_id=" + $v("checklistTaskId") + "] .ckl").attr("title", "CONTINUE CHECKLIST").addClass("t_ai_check_has");
                        vms.checklist.$btnContainer.find('.t_pm_button').remove();
                        vms.checklist.$btnContainer.append(d.btn);
                    }
                } else if (d.noRefresh) {
                    if (pNextQ == 0) vms.checklist.end("C", pTaskId, vResponse);
                    else if (pNextQ) vms.checklist.openQ(pNextQ, pqMax);
                } else alert("Err " + d);
            }
        });
		//checklistSeqNoColor(pNextQ-1,vResponse);
};
/* Created on 30.06.2017 by Davor (checklistShiftQ)*/
vms.checklist.shiftQ = function (pDiff, pMax) {
    var vCurSeq = Number($(".circle-text").text());
    var vNewSeq = vCurSeq + pDiff;
    var vTaskId = "";
    vms.checklist.submitQ(vNewSeq, vTaskId, pMax);
}
/* Created on 29.06.2017 by Davor (checklistSetIrResponse)*/
vms.checklist.setIrResponse = function (pQuestionId, pResponse, pqMax, pHistory) {
    var vChecklistType = $v("checklistType");
    var $vRow = $(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "]");
    var vNewResponse, vOldResponse = $vRow.find(".resp").html();
    if (typeof pResponse == "undefined" || !pResponse) vNewResponse = null;
    else vNewResponse = pResponse;
    console.log(vNewResponse);
    $vRow.find(".resp").html(vNewResponse);
    // seqno color
    if (!vNewResponse) $vRow.find("td#seqno").addClass("blue").removeClass("green yellow");
    else if (vOldResponse && vNewResponse != vOldResponse) $vRow.find("td#seqno").addClass("yellow").removeClass("blue green");
    else $vRow.find("td#seqno").addClass("green").removeClass("blue yellow");

	if ($v("checklistStatus")=='C' || $v("checklistStatus")=='R' || (($v("checklistStatus")=='A' || $v("checklistStatus")=='P') && $v("taskClosed")=='Y')) {
		$(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "] .review").text($v("profileIdFol"));
	}
	else {
		$(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "] .submited").text($v("profileIdFol"));
		$(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "] .review").html("");
	}

    var vNote = $v("chklNote");
    if (vNote) {
        //$(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "] .chklNoteIcon").removeClass("hidden");
		$("#note" + pQuestionId).css("display", "table-row");
        $("#note" + pQuestionId + " td:nth-child(2)").text(vNote);
    }
	//vms.checklist.responseHistory(pQuestionId);
    if (pHistory){
        $("#history"+pQuestionId).remove();
        $(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "]").after(pHistory);
    }

    var vFullCnt = 0;
    $("tr.question").each(function () { if ($(this).find(".resp").text() != "") vFullCnt++; });
    $(".chklProgress").val(vFullCnt);
    var vPercent = Math.round((vFullCnt / pqMax) * 100);
    $(".percentNo").text(vPercent + "%");
    /*if(vms.checklist.questionCnt == vFullCnt) $(".chklBtn.finish.hidden").removeClass("hidden");
    else $(".chklBtn.finish").addClass("hidden");*/
};

/* Created on 29.06.2017 by Davor (checklistResponseShow)
* 12.04.2021 Depricated refreshed answer returned in submit procedure
*/
vms.checklist.responseShow = function (pChecklistId, pQuestionId, pResponse) {
    var vChecklistType = $v("checklistType");
	apex.server.process("checklistResponseShow"
        , { x01: pChecklistId
		  , x02: pQuestionId
		  , x03: pResponse
		  }
        , {
            dataType: "text",
            success: function (ret) {
				$(".vms" + vChecklistType + " tr[qid=" + pQuestionId + "] .resp").html(ret);
            }
        }
	);
};
/* Created on 30.06.2017 by Davor (cReviewResponse) NO-REFERENCE?? */
vms.checklist.responseReview = function (pThis) {
    var vChkId = $v("checklistId");
    var vQuestionId = $(pThis).closest("tr").attr("qid");
    apex.server.process("checklistReview"
        , { x01: vChkId, x02: vQuestionId }
        , {
            dataType: "text",
            success: function (pData) {
                if (pData.trim().substring(0, 2) == "OK") {
                    $(pThis).text($v("profileIdFol"));
                    if (pData.trim().substring(2).length > 0)
                        $(".chklStatus").text(pData.trim().substring(2));
                } else alert("Err " + pData);
            }
        });
};
/* Created on 30.06.2017 by Davor (cResponseHistory)
* 12.04.2021 Depricated refreshed history returned in submit procedure
*/
vms.checklist.responseHistory = function (pQuestionId) {
    var vChkId = $v("checklistId");
    var vQuestionId = pQuestionId;
    var vChecklistType = $v("checklistType");
	/*alert(vChkId+"-"+vQuestionId+"-"+vChecklistType);*/
    /*$(".surveyResponseHistory").remove();*/
	$("#history"+vQuestionId).remove();
    apex.server.process("checklistRespHistory"
        , { x01: vChkId, x02: vQuestionId, x03: $v("checklistOwner") }
        , {
            dataType: "html",
            success: function (pData) {
				/*$("tr:[qid=="chapter"]").append(pData);*/
				$(".vms" + vChecklistType + " tr[qid=" + vQuestionId + "]").after(pData);
			}
        });
}
/* Created on 30.06.2017 by Davor (checklistEnd)*/
vms.checklist.end = function (pStatus, pTaskId, pResponse) {
    var vChkId = $v("checklistId");
    var vFullCnt = 0;
	var seqNo, resp = '';
    vms.checklist.questionCnt = $(".chklProgress").attr("max");
    $("tr.question").each(function () {
		seqNo = $(this).find("#seqno").text();
		resp = $(this).find(".resp").text();
		if (seqNo != vms.checklist.questionCnt) {
			if (resp != "") {
				vFullCnt++; //alert("other-"+resp);
			}
		}
		else {
			if (resp != "") {//|| pResponse != null
				vFullCnt++; //alert("last-"+resp);
			}			
		}
		}
	);
	//alert(vms.checklist.questionCnt+"~"+vFullCnt);
    //var vChecklistType = $v("checklistType");
    //if (vms.checklist.questionCnt == vFullCnt) {
        vms.load.add(null, true);
        apex.server.process("checklistStatusSet"
        , { x01: vChkId, x02: "C", x03: vms.checklist.btnType }
        , {
            dataType: "json",
            success: function (d) {
                vms.load.remove();
                $(".chklStatus").text(d.status);
                $(".chklQuestion,.chklBtnContainer").hide();
                // refresh button
                vms.checklist.$btnContainer.find('.t_pm_button').remove();
                vms.checklist.$btnContainer.append(d.btn);
                if (d.status) vms.checklist.$btnContainer.prev('td').text(d.status);
                //$(".t_task[task_id=" + $v("checklistTaskId") + "] .ckl").attr("title", "PREVIEW CHECKLIST");
				vms.checklist.close($('.vmsSlide.checklist'));
                /*if (vChecklistType=='Popup') {
					$('.vmsPopup.checklist').remove();
				}
				else {
					$('.vmsInline').remove();
				}*/
                // Close task
                if (d.closeLink) eval(d.closeLink);
				/*console.log('pre close task');
                if (pTaskId) setTimeout(lxCloseTask(pTaskId), 2000);
				console.log('post close task');*/
            }
        });
    //} else alert((vms.checklist.questionCnt - vFullCnt) + " question(s) are empty, please fill them and then try again.");
}

vms.checklist.dpaSign = function (pChklId, pSign) {
    vms.load.add(null, true);
        apex.server.process("checklistDpaSign"
        , { x01: pChklId, x02: pSign }
        , {
            dataType: "json",
            success: function (d) {
                vms.load.remove();
                if (d.status) vms.checklist.$btnContainer.prev('td').text(d.status);
				vms.checklist.close($('.vmsSlide.checklist'));
            }
        });
}

vms.checklist.confirmAudit = function (pChklId) {
    vms.load.add(null, true);
	apex.server.process("checklistConfirmAudit"
	, { x01: pChklId}
	, {
		dataType: "text",
		success: function (d) {
			vms.load.remove();
			vms.checklist.close($('.vmsSlide.checklist'));
		}
	});
}